module.exports = new __parcel__URL__("gasa_embassy_level_1.cec1e582.png").toString();